import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { useTenantStore } from '@/store/tenant'

/**
 * Wrapper for unauthenticated pages (login, forgot/reset password).
 * Redirects to / if the user is already authenticated.
 */
export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const theme = useTenantStore((s) => s.theme)

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface-raised px-4 py-12">
      {/* Tenant logo / app name */}
      <div className="mb-8 flex flex-col items-center gap-3">
        {theme?.logoUrl ? (
          <img
            src={theme.logoUrl}
            alt={theme.appName}
            className="h-12 w-auto object-contain"
          />
        ) : (
          <span className="text-2xl font-bold text-primary">
            {theme?.appName ?? 'Telematics'}
          </span>
        )}
      </div>

      {/* Page content */}
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  )
}
